import { render, staticRenderFns } from "./stepFive.vue?vue&type=template&id=aed9d6dc&"
import script from "./stepFive.vue?vue&type=script&lang=js&"
export * from "./stepFive.vue?vue&type=script&lang=js&"
import style0 from "./stepFive.vue?vue&type=style&index=0&id=aed9d6dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports